import * as React from "react"
import { Script } from 'gatsby'
import { ShopifyProvider } from "@/context/ShopifyContext"
import "./styles/global.css";
require('typeface-montserrat')

export const wrapRootElement = ({ element }) => (
  <ShopifyProvider>
    {element}
    <Script
      id="gtm-head"
      strategy='idle'
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-545B9SVD');`,
      }}
    />
    <Script
      id="mautic-tracking"
      strategy='idle'
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
          w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
          m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
          })(window,document,'script','https://m.mossandiamond.com/mtc.js','mt');
          mt('send', 'pageview', {site_id: 'mossan', tags: 'mossan'});`,
      }}
    />
    <noscript key="gtm-noscript">
      <iframe title='gtm-noscript' src="https://www.googletagmanager.com/ns.html?id=GTM-545B9SVD"
        height="0" width="0" style={{"display": "none", "visibility":"hidden"}}></iframe>
    </noscript>
    <Script 
      src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js" 
      strategy="idle"
    />
    <Script
      id="onesignal-init"
      strategy="idle"
      dangerouslySetInnerHTML={{
        __html: `
          window.OneSignalDeferred = window.OneSignalDeferred || [];
          OneSignalDeferred.push(async function(OneSignal) {
            await OneSignal.init({
              appId: "88ab2e53-b211-4cbc-afd2-e28471c33a35",
            });
          });
        `,
      }}
    />
  </ShopifyProvider>
)

// 全局智能预加载控制器
export const onClientEntry = () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    require('intersection-observer'); // 改为require方式
  }

  if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
    // 当.card元素进入观察区域时（视口外200px即开始观察）
    const preloadObserver = new IntersectionObserver((entries) => {  
      entries.forEach(entry => {
        if (entry.isIntersecting) { // 当元素进入观察阈值时
          // 获取卡片内所有懒加载图片
          const images = entry.target.querySelectorAll('img[loading="lazy"]');
          images.forEach(img => {
            // 提升加载优先级
            img.loading = 'eager';  // 立即加载
            img.setAttribute('fetchpriority', 'high'); // 高优先级
            
            // 添加平滑加载效果 // 添加渐显动画
            img.style.transition = 'opacity 0.3s ease';
            img.style.opacity = '0';
            
            // 图片解码完成后显示
            img.decode().then(() => {
              img.style.opacity = '1';
            }).catch(() => {
              img.style.opacity = '1';
            });
          });
          
          preloadObserver.unobserve(entry.target); // 停止观察已处理的元素
        }
      });
    }, {
      rootMargin: '200px 0px',  // 提前200px触发观察
      threshold: 0.001,         // 1像素进入即触发
      trackVisibility: true,    // 跟踪元素可见性
      delay: 100                // 防抖延迟
    });

    // 自动观察所有产品卡片
    document.querySelectorAll('.card').forEach(card => {
      preloadObserver.observe(card);  // 开始观察每个卡片元素
    });
  }
};